/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Clarity_DescriptionInputs */

const en_admin_settings_groups_clarity_description = /** @type {(inputs: Admin_Settings_Groups_Clarity_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inject the Clarity tag for heatmaps and session recordings`)
};

/**
* | output |
* | --- |
* | "Inject the Clarity tag for heatmaps and session recordings" |
*
* @param {Admin_Settings_Groups_Clarity_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_clarity_description = /** @type {((inputs?: Admin_Settings_Groups_Clarity_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Clarity_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_clarity_description(inputs)
});
export { admin_settings_groups_clarity_description as "admin.settings.groups.clarity.description" }